<button
    *ngFor="let color of colors | keyvalue : originalOrder"
    type="button"
    class="t-button"
    [style.background]="color.value"
    [tuiHint]="color.key"
    [tuiHintDescribe]="color.key"
    [id]="color.key"
    (click)="selectedColor.emit(color.value)"
></button>
